module.exports = __webpack_public_path__ + "img/logo.4cebc78a.png";